<template>
  <div class="card">
    <div class="card-body">
      <b-table
        striped
        bordered
        show-empty
        responsive="sm"
        :fields="fields"
        class="datatables"
        :items="tableItems"
      >
        <template #cell(DTNASCIMENTO)="data">
          <div class="d-flex align-items-center justify-content-between">
            <span>{{ data.item.DTNASCIMENTO }} </span>
            <img
              v-if="dataAniversario(data.item.DTNASCIMENTO)"
              :src="birthdayGif"
              alt="Birthday GIF"
              width="30"
            />
          </div>
        </template>

        <template #cell(NMMUNICIPIO)="data">
          <div class="d-flex align-items-center justify-content-between">
            <span v-if="data.item.NMMUNICIPIO">
              {{ data.item.NMMUNICIPIO }} - {{ data.item.DSUF }}
            </span>
          </div>
        </template>

        <template #cell(interacao)="data">
          <div class="d-flex justify-content-center gap-2">
            <b-button
              size="sm"
              variant="primary"
              :disabled="loadingAcoes"
              @click="emitirEditarItem(data.item)"
            >
              <i class="mdi mdi-pencil"></i>
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              @click="deletarClienteRural(data.item)"
              class="d-flex align-items-center justify-content-center"
              :disabled="loadingDeleteId === data.item.SQCLIENTE"
            >
              <template v-if="loadingDeleteId === data.item.SQCLIENTE">
                <b-spinner small></b-spinner>
              </template>
              <i v-else class="mdi mdi-trash-can"></i>
            </b-button>
          </div>
        </template>

        <template #empty>
          <div class="text-center">
            <span class="text-muted">{{ defaultMensagem }}</span>
          </div>
        </template>
      </b-table>

      <div class="d-flex justify-content-end mt-3">
        <b-pagination
          :total-rows="total"
          :per-page="pageSize"
          :value="currentPage"
          @input="onPageChange"
          class="pagination pagination-rounded mb-0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { paginacaoClientesRuraisHelper } from "@/store/helpers/vuex/astec";

export default {
  name: "Grid",
  props: {
    filtro: { type: Object, default: () => ({}) },
    items: { type: [Array, Object], default: () => [] },
    defaultMensagem: { type: String, default: "Nenhum registro disponível." }
  },

  data() {
    return {
      fields: [
        {
          key: "SQCLIENTE",
          label: "Código",
          descricao: "Código do cliente",
          sortable: true
        },
        {
          key: "NMRAZAO",
          label: "Cliente Rural",
          descricao: "Nome do cliente rural",
          sortable: true
        },
        {
          key: "NRCPFCNPJ",
          label: "CPF/CNPJ",
          descricao: "Documento de identificação",
          sortable: true
        },
        { key: "NRTELEFONE", label: "Telefone" },
        {
          key: "DSEMAIL",
          label: "E-mail",
          descricao: "Endereço de e-mail",
          sortable: true
        },
        {
          key: "NMMUNICIPIO",
          label: "Município",
          descricao: "Nome do município",
          sortable: true
        },
        {
          key: "DTNASCIMENTO",
          label: "Data Nascimento",
          descricao: "Data de nascimento do cliente",
          sortable: true
        },
        { key: "interacao", label: "Ações" }
      ],
      loadingAcoes: false,
      loadingDeleteId: null,
      birthdayGif: require("@/assets/images/gif/birthday.gif")
    };
  },

  computed: {
    ...paginacaoClientesRuraisHelper({
      state: ["currentPage", "pageSize", "total"],
      getters: ["currentPage", "pageSize", "total", "totalPages"],
      actions: []
    }).computed,

    tableItems() {
      if (this.items && this.items.dados && Array.isArray(this.items.dados)) {
        return [...this.items.dados];
      }
      if (Array.isArray(this.items)) {
        return [...this.items];
      }
      return [];
    }
  },

  methods: {
    emitirEditarItem(item) {
      this.$emit("editarItem", item);
    },

    deletarClienteRural(item) {
      Swal.fire({
        title: "Tem certeza?",
        text:
          "Você realmente deseja excluir este cliente rural? Essa ação não pode ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.isConfirmed) {
          this.loadingDeleteId = item.SQCLIENTE;

          const obj = {
            cdCooperado: item.CDCOOPERADO,
            sqCliente: item.SQCLIENTE
          };

          this.$http
            .post("/api/astec/deletarClientesRurais", obj)
            .then(() => {
              Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Cliente rural excluído com sucesso!"
              });

              this.$emit("clientesRuraisFiltrados", {
                ...this.filtro,
                page: this.currentPage,
                per_page: this.pageSize
              });
            })
            .catch(err => {
              console.log("Erro ao deletar cliente rural", err.response?.data);
              this.$tools.alerta(err.response?.data, "error");
            })
            .finally(() => {
              this.loadingDeleteId = null;
            });
        }
      });
    },

    dataAniversario(dataNascimento) {
      if (!dataNascimento) return false;
      const hoje = new Date();
      const [dia, mes] = dataNascimento.split("/").slice(0, 2);
      return (
        parseInt(dia) === hoje.getDate() &&
        parseInt(mes) === hoje.getMonth() + 1
      );
    },

    onPageChange(page) {
      this.$emit("clientesRuraisFiltrados", {
        ...this.filtro,
        page,
        per_page: this.pageSize
      });
    }
  }
};
</script>
